import React from "react";
import { Menu, Icon } from "antd";
import { Layout } from "antd";
import { Link, withRouter} from "react-router-dom";


import ArticlesIcon from "./files/articlesIcon.js";
import HomeIcon from "./files/homeIcon.js";
import LoginIcon from "./files/loginIcon.js";
import DescriptionIcon from "./files/descriptionIcon.js";
import HeatmetersIcon from "./files/heatmetersIcon.js";
import ReviewsIcon from "./files/reviewsIcon.js";
import LicensesIcon from "./files/licensesIcon.js";
import SettingsIcon from "./files/settingsIcon.js";

import ContactsIcon from "./files/contactsIcon.js";

import styles from "./menu.module.css";

const { Sider } = Layout;

class MMenu extends React.Component {
  state = {
    collapsed: false,
    selectedSubMenu: "default",
    menuItemIndex: "/"
  };

  toggle = () => {
    this.setState({
      collapsed: !this.state.collapsed
    });

    this.props.menuShrinkHandler(!this.state.collapsed);
  };

  handleClick = e => {
    this.setState({
      menuItemIndex: e.key
    });
    this.props.menuItemHandler(e.key);
  };

  render() {
    const { location } = this.props;
      
    return (
      <Sider
        trigger={null}
        collapsible
        collapsed={this.state.collapsed}
        onCollapse={this.toggle}
        className={styles.sider}
        //width={this.state.collapsed ? "auto" : "14vw"}
        theme="light"
        style={{
          justifySelf: "flex-start",
          gridArea: "m",
          marginLeft: "1.5vw",
          //height: "77vh",
          height: "42.05em",
          background: "rgba(225, 235, 245, 0.68)",
          //position: "-webkit-sticky",
          //position: "sticky",
          //top: "11vh"
          top: this.props.isCarousel ? "11.5ex" : "11ex"
        }}
      >
        <Icon
          className={styles.toogleButton}
          type={this.state.collapsed ? "menu-unfold" : "menu-fold"}
          onClick={this.toggle}
        />

        <Menu
          className={styles.menu}
          theme="light"
          mode="vertical"
          defaultSelectedKeys={["1"]}
          selectedKeys={[location.pathname]}
          onClick={this.handleClick}
        >
          <Menu.Item
            className={
              this.state.menuItemIndex === "/"
                ? styles.customActiveMain
                : null
            }
            key="/"
            onClick={event =>
              this.setState(state => {
                return { selectedSubMenu: "default" };
              })
            }
          >
            <HomeIcon />
            <span>Главная</span>
            <Link to="/" />
          </Menu.Item>
          <Menu.Item
            className={
              this.props.currentSlide === 1 && this.state.menuItemIndex === "/"
                ? styles.customActive
                : null
            }
            key="/login"
            onClick={event =>
              this.setState(state => {
                return { selectedSubMenu: "default" };
              })
            }
          >
            <LoginIcon />
                    <span>Личный кабинет</span>
          </Menu.Item>

          <Menu.Item
            className={
              this.props.currentSlide === 2 && this.state.menuItemIndex === "/"
                ? styles.customActive
                : null
            }
            key="/solutions"
            onClick={event =>
              this.setState(state => {
                return { selectedSubMenu: "default" };
              })
            }
          >
            <Icon type="solution" />
            <span>Решения</span>
            <Link to="/solutions" />
          </Menu.Item>

          {/*
          <SubMenu
            className={
              this.props.currentSlide === 2 ? styles.customActive : null
            }
            id={
              this.state.selectedSubMenu === "solutions"
                ? submenuSelected
                : null
            }
            key="/solutions"
            title={
              <span>
                <Icon type="solution" />
                <span>Решения</span>
              </span>
            }
            onTitleClick={i => {
              this.props.history.push("/solutions");

              this.setState(state => {
                return { selectedSubMenu: "solutions" };
              });
            }}
          >
            <Menu.Item
              key="/solutions1"
              onClick={event =>
                this.setState(state => {
                  return { selectedSubMenu: "solutions" };
                })
              }
            >
              <span>АСКУЭ</span>
              <Link to="/solutions1" />
            </Menu.Item>
            <Menu.Item
              key="/solutions2"
              onClick={event =>
                this.setState(state => {
                  return { selectedSubMenu: "solutions" };
                })
              }
            >
              <span>СМИУ</span>
              <Link to="/solutions2" />
            </Menu.Item>
          </SubMenu>
            */}
          <Menu.Item
            className={
              this.props.currentSlide === 3 && this.state.menuItemIndex === "/"
                ? styles.customActive
                : null
            }
            key="/description"
            onClick={event =>
              this.setState(state => {
                return { selectedSubMenu: "default" };
              })
            }
          >
            <DescriptionIcon />
            <span>Описание системы</span>

            <Link to="/description" />
          </Menu.Item>
          <Menu.Item
            className={
              this.props.currentSlide === 4 && this.state.menuItemIndex === "/"
                ? styles.customActive
                : null
            }
            key="/hmeters"
            onClick={event =>
              this.setState(state => {
                return { selectedSubMenu: "default" };
              })
            }
          >
            <HeatmetersIcon />
            <span>Счетчики</span>
            <Link to="/hmeters" />
          </Menu.Item>
          <Menu.Item
            className={
              this.props.currentSlide === 5 && this.state.menuItemIndex === "/"
                ? styles.customActive
                : null
            }
            key="/connection"
            onClick={event =>
              this.setState(state => {
                return { selectedSubMenu: "default" };
              })
            }
          >
            <Icon type="api" />
            <span>Подключение</span>
            <Link to="/connection" />
          </Menu.Item>
          <Menu.Item
            key="/news"
            onClick={event =>
              this.setState(state => {
                return { selectedSubMenu: "default" };
              })
            }
          >
            <Icon type="notification" />
            <span>Новости</span>
            <Link to="/news" />
          </Menu.Item>
          <Menu.Item
            className={
              this.props.currentSlide === 6 && this.state.menuItemIndex === "/"
                ? styles.customActive
                : null
            }
            key="/tariffs"
            onClick={event =>
              this.setState(state => {
                return { selectedSubMenu: "default" };
              })
            }
          >
            <Icon type="profile" />
            <span>Тарифы</span>
            <Link to="/tariffs" />
          </Menu.Item>
          <Menu.Item
            className={
              this.props.currentSlide === 7 && this.state.menuItemIndex === "/"
                ? styles.customActive
                : null
            }
            key="/articles"
            onClick={event =>
              this.setState(state => {
                return { selectedSubMenu: "default" };
              })
            }
          >
            <ArticlesIcon />
            <span>Статьи</span>
            <Link to="/articles" />
          </Menu.Item>
          <Menu.Item
            className={
              this.props.currentSlide === 8 && this.state.menuItemIndex === "/"
                ? styles.customActive
                : null
            }
            key="/feedback"
            onClick={event =>
              this.setState(state => {
                return { selectedSubMenu: "default" };
              })
            }
          >
            <ReviewsIcon />
            <span>Отзывы</span>
            <Link to="/feedback" />
          </Menu.Item>
          <Menu.Item
            className={
              this.props.currentSlide === 9 && this.state.menuItemIndex === "/"
                ? styles.customActive
                : null
            }
            key="/licenses"
            onClick={event =>
              this.setState(state => {
                return { selectedSubMenu: "default" };
              })
            }
          >
            <LicensesIcon />
            <span>Лицензии</span>
            <Link to="/licenses" />
          </Menu.Item>
          <Menu.Item
            className={
              this.props.currentSlide === 10 && this.state.menuItemIndex === "/"
                ? styles.customActive
                : null
            }
            key="/partners"
            onClick={event =>
              this.setState(state => {
                return { selectedSubMenu: "default" };
              })
            }
          >
            <Icon type="team" />
            <span>Партнеры</span>
            <Link to="/partners" />
          </Menu.Item>
          <Menu.Item
            key="/tutorial"
            onClick={event =>
              this.setState(state => {
                return { selectedSubMenu: "default" };
              })
            }
          >
            <SettingsIcon />
            <span>Настройка приборов</span>
            <Link to="/tutorial" />
          </Menu.Item>
          <Menu.Item
            className={
              this.props.currentSlide === 11 && this.state.menuItemIndex === "/"
                ? styles.customActive
                : null
            }
            key="/contacts"
            onClick={event =>
              this.setState(state => {
                return { selectedSubMenu: "default" };
              })
            }
          >
            <ContactsIcon />
            <span>Контакты</span>
            <Link to="/contacts" />
          </Menu.Item>
        </Menu>
      </Sider>
    );
  }
}

const RMMenu = withRouter(MMenu);
export default RMMenu;
